export default {
  disponibileBio: 'Disponibile Bio',
  certificatoBio: 'Certificato Bio',
  'Certificato Bio': 'Certificato Bio',
  'Disponibile Bio': 'Disponibile Bio',
  vino: 'Vino',
  birra: 'Birra',
  panificati: 'Panificati',
  agricoltura: 'Agricoltura',
  nutraceutica: 'Nutraceutica',
  altriProdotti: 'Altri prodotti della stessa famiglia',
  structuredTitle: "Potenzia l'efficacia di {title} con:",
  prefix: {
    vino: 'Vini',
  },
  adattoPer: 'Adatto per',
  stili: 'Stili',
  disponibilitaProdotto: 'Disponibile nei formati: ',
}
